(function($) {

  $('.home-section-one .widget_siteorigin-panels-builder .panel-layout .panel-grid .panel-grid-cell').bxSlider({
    randomStart: true,
    easing: 'ease-out',
    pager: false
  });

})(jQuery);